import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function FinalCTA() {
  const { ref, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section className="relative overflow-hidden bg-[#0A0A0A]">
      {/* BG Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/2cfc2dedb3b6a43911ac617893ff5f92.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-[#0A0A0A]/88" />

      {/* Horizontal gold lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A030]/40 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C9A030]/30 to-transparent" />

      <div
        ref={ref}
        className={`relative z-10 w-full px-6 lg:px-14 py-28 text-center fade-up ${isVisible ? 'visible' : ''}`}
      >
        <div className="max-w-3xl mx-auto">
          <p className="overline mb-6">Take the First Step</p>

          <h2 className="font-serif text-5xl lg:text-7xl font-light text-[#F2EDE3] leading-[1.08] mb-6">
            Your Compliance<br />
            <em className="not-italic text-[#C9A030]">Guaranteed.</em>
          </h2>

          <p className="text-[#9A9A9A] text-base font-light leading-relaxed mb-10 max-w-xl mx-auto">
            No contracts. No long commitments. Just guaranteed results for ISNetworld, Veriforce, and Avetta — handled by the same expert who knows your business.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
            <Link
              to="/contact"
              className="bg-[#C9A030] text-[#0A0A0A] px-9 py-4 text-[11px] font-bold tracking-[0.25em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-[#D4B045]"
            >
              Get Compliant Today
            </Link>
            <a
              href="tel:4054081117"
              className="border border-[#F2EDE3]/25 text-[#F2EDE3]/70 px-9 py-4 text-[11px] font-medium tracking-[0.25em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:border-[#C9A030]/60 hover:text-[#C9A030]"
            >
              Call 405-408-1117
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: 'ri-shield-check-fill', label: '100% Approval Guaranteed' },
              { icon: 'ri-calendar-line', label: 'Month-to-Month' },
              { icon: 'ri-close-circle-line', label: 'Cancel Anytime' },
            ].map((item) => (
              <div key={item.label} className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-[#C9A030] text-sm`} />
                </span>
                <span className="text-[#5A5A5A] text-[10px] tracking-[0.2em] uppercase font-light">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
